import { layout } from 'src/styles/layout';
import styled from 'styled-components';

export const CoursesVideoContainer = styled.div`
  padding: 5em 0 5em;
  
  & > h1 {
    margin-bottom: 1rem;
  }
  & > p {
    max-width: 480px;
    margin: 0 auto;
  }
  
  @media all and (max-width: ${layout.subLg}) {
    padding: 2.5em 0 1em;
  }
`;

export const CoursesModalVideoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 2em 0;
  max-width: 100vw;

  > img {
    max-width: 100%;
  }
`
